<template>
  <GetStartedInstructions
    ref="getStartedInstructions"
    :class="$style.recommendedPoliciesCollapsable"
    :dismissButtonText="'dismiss forever'"
    :localStorageKey="localStorageKey"
    :startCollapsed="collapsed"
    :title="title"
  >
    <p :class="$style.carouselHeaderText">
      {{ headerText }}
      <a
        href="https://support.jumpcloud.com/support/s/article/getting-started-policies-2019-08-21-10-36-47"
        rel="noopener noreferrer"
        target="_blank"
        @click="linkEvent()"
      >
        Learn how.
      </a>
    </p>
    <RecommendedPoliciesCarousel
      :class="$style.policiesCarousel"
      :itemType="itemType"
      @remainingPoliciesLengthCheck="handleRemainingPoliciesLengthCheck"
    />
  </GetStartedInstructions>
</template>

<script>
import { ItemTypeConsts, LocalStorageConsts } from 'client/util/Constants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import GetStartedInstructions from 'components/GetStartedInstructions/GetStartedInstructions.vue';
import ItemType from 'client/util/Constants/ItemType';
import RecommendedPoliciesCarousel from 'client/policies/RecommendedPoliciesCarousel.vue';

const { recommendedPoliciesCarouselDismissed } = LocalStorageConsts;
const { DeviceItemType, DeviceGroupItemType, ConfigurationItemType } = ItemType;
const deviceItem = new DeviceItemType();
const deviceGroupItem = new DeviceGroupItemType();
const configurationItem = new ConfigurationItemType();

export default {
  name: 'RecommendedPoliciesCarouselCollapsableSection',
  components: {
    GetStartedInstructions,
    RecommendedPoliciesCarousel,
  },

  props: {
    itemType: {
      type: String,
      default: ItemTypeConsts.configuration,
    },
  },

  data: () => ({
    collapsed: false,
    localStorageKey: recommendedPoliciesCarouselDismissed,
    numberOfPolicies: 0,
  }),

  computed: {
    headerText() {
      return `Protect and configure user ${deviceItem.labelPlural} by applying
      ${configurationItem.labelPlural} to ${deviceGroupItem.labelPlural}.`;
    },
    title() {
      const title = `Recommended ${configurationItem.titlePlural}`;

      if (this.numberOfPolicies) return `${title} (${this.numberOfPolicies})`;

      return title;
    },
  },

  methods: {
    handleRemainingPoliciesLengthCheck(remainingPoliciesLength) {
      if (remainingPoliciesLength === 1) this.$refs.getStartedInstructions.handleDismiss();
      this.numberOfPolicies = remainingPoliciesLength - 1;
    },
    linkEvent() {
      EventHelper.triggerCollapsableSectionLinkClicked({
        sectionTitle: this.title,
        text: 'Learn how.',
        url: 'https://support.jumpcloud.com/support/s/article/getting-started-policies-2019-08-21-10-36-47',
      });
    },
  },
};
</script>

<style module>

.carouselHeaderText,
.policiesCarousel {
  display: block;
}

.recommendedPoliciesCollapsable ul {
  flex-direction: column;
}
</style>
